export default __webpack_public_path__ + "static/media/atUST.27619054.svg";